'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('bootstrap/dist/css/bootstrap-grid.css');

var _reactstrap = require('reactstrap');

var _aphrodite = require('aphrodite');

var _index = require('../colors/index');

var _lumosity_logo = require('../../assets/lumosity_logo.png');

var _lumosity_logo2 = _interopRequireDefault(_lumosity_logo);

var _Buttons = require('../Buttons');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var styles = _aphrodite.StyleSheet.create({
  header: {
    backgroundColor: _index.lumosWhite,
    height: 100,
    paddingTop: 20,
    marginLeft: 'auto',
    marginRight: 'auto',
    '@media (max-width: 767px)': {
      height: 62,
      paddingTop: 5,
      paddingBottom: 10
    }
  },
  logo: {
    float: 'left'
  },
  logoImg: {
    marginTop: 15,
    height: 31,
    width: 125
  },
  ctasContainer: {
    float: 'right',
    marginTop: 15,
    height: 24,
    '@media (max-width: 767px)': {
      marginTop: 12
    }
  },
  hideOnSmaller: {
    '@media (max-width: 767px)': {
      display: 'none'
    }
  },
  cta: {
    fontSize: 12,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '1px',
    float: 'left',
    marginRight: 10,
    marginTop: -7,
    '@media (max-width: 767px)': {
      padding: '10px 20px'
    }
  },
  login: {
    color: _index.gray7,
    backgroundColor: _index.gray2,
    ':focus': {
      outline: 'none'
    },
    ':hover': {
      backgroundColor: '#eee'
    },
    ':active': {
      backgroundColor: '#d5d5d5'
    }
  }
});

function Header(props) {
  var links = props.links;
  return _react2.default.createElement('div', {
    className: (0, _aphrodite.css)(styles.header)
  }, _react2.default.createElement(_reactstrap.Container, null, _react2.default.createElement('div', {
    className: (0, _aphrodite.css)(styles.logo)
  }, _react2.default.createElement('a', {
    href: links.logo.href,
    'data-track': links.logo.track,
    'data-track-link-click': links.logo.trackLinkClick,
    'data-track-location': links.logo.trackLocation
  }, _react2.default.createElement('img', {
    src: _lumosity_logo2.default,
    className: (0, _aphrodite.css)(styles.logoImg),
    alt: 'Lumosity Logo'
  }))), _react2.default.createElement('span', {
    className: (0, _aphrodite.css)(styles.ctasContainer)
  }, _react2.default.createElement(_Buttons.RoundedButton, {
    styles: [styles.cta, styles.hideOnSmaller],
    value: 'Get Started Now',
    href: links.getStarted.href,
    track: links.getStarted.track,
    trackButtonPress: links.getStarted.trackButtonPress,
    trackLocation: links.getStarted.trackLocation
  }), _react2.default.createElement(_Buttons.RoundedButton, {
    styles: [styles.cta, styles.login],
    value: 'Log In',
    href: links.login.href,
    track: links.login.track,
    trackButtonPress: links.login.trackButtonPress,
    trackLocation: links.login.trackLocation
  }))));
}

exports.default = Header;
Header.propTypes = {
  /** Where to link each button into */
  links: _propTypes2.default.shape({
    logo: _propTypes2.default.shape({
      href: _propTypes2.default.string.isRequired,
      track: _propTypes2.default.string,
      trackLinkClick: _propTypes2.default.string,
      trackLocation: _propTypes2.default.string
    }),
    getStarted: _propTypes2.default.shape({
      href: _propTypes2.default.string.isRequired,
      track: _propTypes2.default.string,
      trackButtonPress: _propTypes2.default.string,
      trackLocation: _propTypes2.default.string
    }),
    login: _propTypes2.default.shape({
      href: _propTypes2.default.string.isRequired,
      track: _propTypes2.default.string,
      trackButtonPress: _propTypes2.default.string,
      trackLocation: _propTypes2.default.string
    })
  }).isRequired
};